'use strict';

/*global app*/
/*global services*/
/*global blockElement*/
/*global unBlockElement*/
/*global invokeCallback*/
/*global getItemById*/
/*global resSuccess*/
/*global resError*/

function WarehouseService() {
  this.$container = null;
  this.modal = null;
  this.data = null;

  this.init();
}

WarehouseService.prototype = $.extend({}, {
  constructor: 'WarehouseService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.warehouse-service__select', function () {
      _this.doSelectWarehouse($(this).data('warehouse_id'));
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  doSelectWarehouse: function doSelectWarehouse(warehouseId) {
    var _this = this;

    _this.modal.close(function () {
      _this.data.callback(warehouseId);
    });

    return _this;
  },

  selectWarehouse: function selectWarehouse(data, callback) {
    var _this = this;

    data = data || { title: '' };
    data.callback = callback;

    _this.data = data;
    _this.modal.open({
      modalClass: 'warehouse-service',
      title: data.title || app.t('stock.choose_stock'),
      height: 'auto',
      width: 'md',
      form: false
    }).block();

    $.get(app.path('warehouse_select'), function (res) {
      _this.modal.unBlock();
      _this.modal.content(res.data.html);
    });

    return _this;
  },

  getDisposition: function getDisposition(data, callback) {
    var _this = this;

    $.get(app.formation('stock:get_disposition'), data, function (res) {
      if (res.msg === 'SUCCESS') {
        callback(res.data.IsAvailable, res.data.AvailableAmount);
      } else {
        app.viewErrorMessage(res);
      }
    });

    return _this;
  },

  getArticlePackage: function getArticlePackage(data, callback) {
    var _this = this;

    $.get(app.formation('stock:get_packages'), data, function (res) {
      if (res.msg === 'SUCCESS') {
        var list = [];
        $.each(res.data.list, function (key, item) {
          list.push({
            id: item.Package,
            abbr: item.Package,
          });
        });

        if (list.length === 0) {
          invokeCallback(callback, resSuccess, { value: '', list: [] });
        } else if (list.length === 1) {
          invokeCallback(callback, resSuccess, { value: list[0].id, list: list });
        } else {
          services.get('select-service').selectValueWithRes({ list: list }, function (res, value) {
            invokeCallback(callback, res, { value: value, list: list });
          });
        }
      } else {
        app.viewErrorMessage(res, function () {
          invokeCallback(callback, resError);
        });
      }
    });

    return _this;
  },

  processZeroLevel: function processZeroLevel(data, callback) {
    var _this = this;

    app.confirmHtml(app.t('stock.is_zero_level_confirm'), function (ret) {
      if (!ret) {
        blockElement(_this.$container);
        app.getFormation('stock:create_inv_transfer_note', data, function (res) {
          unBlockElement(_this.$container);
          if (res.msg === 'SUCCESS') {
            if (res.data.IsTransferNoteCreated) {
              app.showMessageHtml(app.t('stock.inv_transfer_note_created_success'), function () {
                invokeCallback(callback);
              });
            } else {
              app.showMessageHtml(app.t('stock.inv_transfer_note_created_failed'), function () {
                invokeCallback(callback);
              });
            }
          } else {
            app.viewErrorMessage(res, function () {
              invokeCallback(callback);
            });
          }
        });
      } else {
        invokeCallback(callback);
      }
    });

    return _this;
  },

  checkZeroStockLevel: function checkZeroStockLevel(data, callback) {
    var _this = this;

    blockElement(_this.$container);
    app.getFormation('stock:is_zero_level', data, function (res) {
      unBlockElement(_this.$container);
      if (res.msg === 'SUCCESS') {
        if (res.data.IsZeroLevel) {
          _this.processZeroLevel(data, callback);
        } else {
          invokeCallback(callback);
        }
      } else {
        app.viewErrorMessage(res, function () {
          invokeCallback(callback);
        });
      }
    });

    return _this;
  },

  isLocationRecord: function isLocationRecord(warehouseId) {
    var warehouse = getItemById(app.param('warehouses'), warehouseId);

    if (warehouse) {
      return warehouse.isLocationRecord;
    }

    return true;
  },

  isHandlingUnitRecord: function isHandlingUnitRecord(warehouseId) {
    var warehouse = getItemById(app.param('warehouses'), warehouseId);

    if (warehouse) {
      return warehouse.isHandlingUnitRecord;
    }

    return true;
  },

  isRequiredConfirmLocation: function isRequiredConfirmLocation(warehouseId) {
    var warehouse = getItemById(app.param('warehouses'), warehouseId);

    if (warehouse) {
      return warehouse.isRequiredConfirmLocation;
    }

    return true;
  },

  isRequiredConfirmArticle: function isRequiredConfirmArticle(warehouseId) {
    var warehouse = getItemById(app.param('warehouses'), warehouseId);

    if (warehouse) {
      return warehouse.isRequiredConfirmArticle;
    }

    return true;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.$container = $('body');
    _this.modal = services.get('modal-input');

    _this.registerCallbacks();

    return _this;
  }
});
